import React from 'react'
import { navigate } from 'gatsby'
import { FiSearch } from "react-icons/fi";

const BlogSearch = (props) => {
    const handleSearch = (e) => {
        e.preventDefault();
        const [search] = e.target.elements;
        const searchText = search.value

        if (searchText.trim() !=='')
            navigate("/blog/?s=" + searchText);
    }

    return (
        <form className="search-form" onSubmit={handleSearch}>
            <input 
                className="form-control form-search"
                id="search"
                type="text"
                name="search"
                placeholder="Busca en nuestro blog"
            />
            <button className="btn-search" type="submit"><FiSearch aria-label="Buscar" /></button>
        </form>
    )
}

export default BlogSearch